import React, { useState, useEffect, useCallback } from "react";
import { SERVER_URL } from "../../../constants.js";
import IconButton from "@mui/material/IconButton";
import { Delete } from "@mui/icons-material";
import EditTransfer from "../../AddsEdits/Student/EditTransfer.js";
import AddTransfer from "../../AddsEdits/Student/AddTransfer.js";
import Stack from "@mui/material/Stack";
import { formatLocalDateOnly } from "../../shared utils/dateFormatters";
import {
    addTransfer,
    editTransfer,
    deleteTransfer,
} from "../../shared utils/transferApi";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { jsonOr } from "../../../utils/http";

function StudentTransfers(props) {
    const { selectedPerson } = props;
    const [transfers, setTransfers] = useState([]);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("success");
const [campuses, setCampuses] = useState([]);
    
    useEffect(() => {
        const token = sessionStorage.getItem("bearer");
        fetch(`${SERVER_URL}api/campuses/active`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => jsonOr(res, []))
            .then((data) => setCampuses(data))
            .catch((err) => console.error("Failed to fetch campuses:", err));
    }, []); 
    const showToast = (message, severity = "success") => {
        setToastMessage(message);
        setToastSeverity(severity);
        setToastOpen(true);
    };
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const fetchTransfers = useCallback(() => {
        const token = sessionStorage.getItem("bearer");
        fetch(`${SERVER_URL}api/transfers/${selectedPerson.id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.status === 204) {
                    return [];
                } else if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch payments");
                }
            })
            .then((data) => {
                sessionStorage.setItem("payments", JSON.stringify(data));
                setTransfers(data);
            })
            .catch((err) => console.error(err));
    }, [selectedPerson.id]);

    useEffect(() => {
        fetchTransfers();
    }, [fetchTransfers]);

    const handleAdd = (transfer, id) => {
        if (!transfer.transferDate) {
            showToast("Transfer date is required", "error");
            return;
        }

        addTransfer(transfer, id)
            .then(() => {
                fetchTransfers();
                showToast("Flight added successfully");
            })
            .catch((err) => {
                const message =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    err?.message ||
                    "Error adding Flight";

                showToast(message, "error");
            });
    };

    const handleEdit = (transfer, id) => {
        if (!transfer.transferDate) {
            showToast("Transfer date is required", "error");
            return;
        }

        editTransfer(transfer, id)
            .then(() => {
                fetchTransfers();
                showToast("Flight edited successfully");
            })
            .catch((err) => {
                const message =
                    err?.response?.data?.message ||
                    err?.response?.data ||
                    err?.message ||
                    "Error editing Flight";

                showToast(message, "error");
            });
    };

    const handleDelete = (event, transfer) => {
        event.preventDefault();
        deleteTransfer(transfer.id)
            .then(() => {
                fetchTransfers();
                showToast("Flight deleted successfully");
            })
            .catch((err) => {
                showToast("Error deleting Flight", "error");
                console.error(err);
            });
    };

    return (
        <React.Fragment>
            <div
                className="detail-card payments-card"
                style={{ padding: "20px 0" }}
            >
                <table
                    style={{
                        width: "80%",
                        textAlign: "left",
                        margin: "auto",
                        borderCollapse: "collapse",
                    }}
                >
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Direction</th>
                            <th>Date</th>
                            <th>Leaving</th>
                            <th>Arriving</th>
                            <th>Self Transfer</th>
                            <th>Depart</th>
                            <th>Arrive</th>
                            <th>UM</th>
                            <th>Notes</th>
                            <th>Flight</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transfers.map((transfer) => (
                            <tr key={transfer.id}>
                                <td>{transfer.id}</td>
                                <td>{transfer.direction}</td>
                                <td>
                                    {formatLocalDateOnly(
                                        new Date(transfer.transferDate)
                                    )}
                                </td>
                                <td>{transfer.depart}</td>
                                <td>{transfer.arrive}</td>
                                <td>{transfer.privatePickup ? "Yes" : "No"}</td>
                                <td>{transfer.departureTime}</td>
                                <td>{transfer.arrivalTime}</td>
                                <td>
                                    {transfer.unaccompaniedMinor ? "Yes" : "No"}
                                </td>
                                <td>{transfer.notes}</td>
                                <td>{transfer.flightId}</td>
                                <td>
                                    <EditTransfer
                                        person_id={selectedPerson.id}
                                        transfer_id={transfer.id}
                                        editTransfer={handleEdit}
                                        campuses={campuses}
                                    />
                                </td>
                                <td>
                                    <IconButton
                                        onClick={(event) =>
                                            handleDelete(event, transfer)
                                        }
                                    >
                                        <Delete color="primary" />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <AddTransfer
                            passedStudent={selectedPerson.id}
                            addTransfer={handleAdd}
                            campuses={campuses}
                        />
                    </Stack>
                </div>
                <p style={{ color: "#999999", fontSize: "10px" }}>
                    Student: {selectedPerson.id}
                </p>
                <p style={{ color: "#999999", fontSize: "10px" }}>
                    Is authenticated:{" "}
                    {sessionStorage.getItem("isAuthenticated").toString()}
                </p>
            </div>
            <Snackbar
                open={toastOpen}
                autoHideDuration={3000}
                onClose={() => setToastOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setToastOpen(false)}
                    severity={toastSeverity}
                >
                    {toastMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}

export default StudentTransfers;
